var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBattery = function SvgBattery(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_849_36056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.00033 4.66699H11.3337C11.6873 4.66699 12.0264 4.80747 12.2765 5.05752C12.5265 5.30756 12.667 5.6467 12.667 6.00033V6.33366C12.667 6.42206 12.7021 6.50685 12.7646 6.56936C12.8271 6.63187 12.9119 6.66699 13.0003 6.66699C13.0887 6.66699 13.1735 6.70211 13.236 6.76462C13.2985 6.82714 13.3337 6.91192 13.3337 7.00033V9.00033C13.3337 9.08873 13.2985 9.17352 13.236 9.23603C13.1735 9.29854 13.0887 9.33366 13.0003 9.33366C12.9119 9.33366 12.8271 9.36878 12.7646 9.43129C12.7021 9.4938 12.667 9.57859 12.667 9.66699V10.0003C12.667 10.3539 12.5265 10.6931 12.2765 10.9431C12.0264 11.1932 11.6873 11.3337 11.3337 11.3337H4.00033C3.6467 11.3337 3.30756 11.1932 3.05752 10.9431C2.80747 10.6931 2.66699 10.3539 2.66699 10.0003V6.00033C2.66699 5.6467 2.80747 5.30756 3.05752 5.05752C3.30756 4.80747 3.6467 4.66699 4.00033 4.66699Z",
    stroke: "#1565C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66699 6.66699V9.33366",
    stroke: "#1565C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66699 6.66699V9.33366",
    stroke: "#1565C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_849_36056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBattery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "battery.0984af4544391f930103533b393532e6.svg";